import React from "react";
export default (({
  styles = {},
  ...props
}) => <svg width="24" height="24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}><path d="M17.222 5H4.778C3.796 5 3 5.796 3 6.778v12.444C3 20.204 3.796 21 4.778 21h12.444c.982 0 1.778-.796 1.778-1.778V6.778C19 5.796 18.204 5 17.222 5zM15 3v4M7 3v4M3 10h16" stroke="#fff" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" /></svg>);